import { render, staticRenderFns } from "./SpecimenView.vue?vue&type=template&id=57ed0442&scoped=true&"
import script from "./SpecimenView.vue?vue&type=script&lang=js&"
export * from "./SpecimenView.vue?vue&type=script&lang=js&"
import style0 from "./SpecimenView.vue?vue&type=style&index=0&id=57ed0442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed0442",
  null
  
)

export default component.exports